import { Controller } from "@hotwired/stimulus"

// Add/remove invite rows on the onboarding "Invite team" step (README Step
// 3) and the Settings invite-member area. Caps at `maxValue` rows, matching
// Organization#invite_cap.
export default class extends Controller {
  static targets = ["rows", "template", "addButton"]
  static values = { max: Number }

  add() {
    if (this.maxValue && this.rowsTarget.children.length >= this.maxValue) return

    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.rowsTarget.appendChild(row)
    this.updateAddButton()
  }

  remove(event) {
    event.target.closest(".invite-row").remove()
    this.updateAddButton()
  }

  updateAddButton() {
    if (!this.hasAddButtonTarget || !this.maxValue) return
    this.addButtonTarget.hidden = this.rowsTarget.children.length >= this.maxValue
  }
}
